import { Box, Heading, Link } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC, Fragment } from 'react';

import { CloseButton } from '@/components/core/CloseButton';
import { useAnalytics } from '@/context/Analytics';
import { NewsArticleTopic } from '@/resources/NewsArticleTopic';

interface IHeaderProps {
  activeArticleTopic?: string;
  articleTopics: Array<NewsArticleTopic>;
}

export const Header: FC<IHeaderProps> = ({ activeArticleTopic, articleTopics }) => {
  const analytics = useAnalytics();

  const handleTopicClick = (topic: string) => {
    return () => {
      analytics.track('article_topic_select', { article_topic: topic });
    };
  };

  return (
    <Fragment>
      <Heading
        as="h1"
        color="black"
        fontSize={{ base: '40px', md: '80px' }}
        lineHeight={{ base: '48px', md: '80px' }}
        mt={{ base: '40px', md: '60px' }}
        mb={{ base: '40px', md: '50px' }}
      >
        Underline{' '}
        {activeArticleTopic ? (
          <Box
            as="span"
            fontFamily="underline"
            color="violet.500"
            display="inline-flex"
            alignItems="center"
            sx={{ svg: { display: 'block' } }}
          >
            {activeArticleTopic}
            <NextLink href="/news" passHref legacyBehavior>
              <CloseButton css={{ marginLeft: '30px' }} size="small" variant="dark" />
            </NextLink>
          </Box>
        ) : (
          <Box as="span" fontFamily="underline">
            News
          </Box>
        )}
      </Heading>

      <Box
        as="ul"
        display="flex"
        flexWrap="wrap"
        alignItems="baseline"
        columnGap="32px"
        rowGap={2}
        listStyleType="none"
        p={0}
        mt="50px"
        mb={{ base: '40px', md: '80px' }}
      >
        {articleTopics.map((topic) => (
          <Box as="li" key={topic.id} minW={0}>
            <Link
              as={NextLink}
              href={`/news?articleTopicId=${topic.id}`}
              onClick={handleTopicClick(topic.name)}
              display="block"
              maxW="500px"
              overflow="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              fontFamily="heading"
              fontWeight="bold"
              fontSize={{ base: '20px', md: '24px' }}
              lineHeight={{ base: '28px', md: '32px' }}
              color="violet.500"
              // the underline font is a hair taller, so pull it back to keep the baseline steady
              _hover={{ fontFamily: 'underline', textDecoration: 'none', mb: '-1px' }}
            >
              {topic.name}
            </Link>
          </Box>
        ))}
      </Box>
    </Fragment>
  );
};
